import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { withBrandWord } from '../primitives/BrandWord';

const PublicModeErrorComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();

  const handleSignUp = useCallback(() => {
    router.push(SMLRoutes.auth);
  }, [router]);

  return (
    <div className="text-center p-5">
      <h3 className="mb-3">
        {intl.formatMessage({
          id: 'app.sml.publicMode.error.title',
          defaultMessage: 'This share link is invalid',
        })}
      </h3>
      <p className="mb-4">
        {withBrandWord(
          intl.formatMessage({
            id: 'app.sml.publicMode.error.message',
            defaultMessage:
              'The link may have been tampered with or is no longer valid. Sign up to explore MUSIC24 yourself.',
          })
        )}
      </p>
      <Button color="primary" onClick={handleSignUp}>
        {intl.formatMessage({
          id: 'app.sml.publicMode.error.cta.paidOnly',
          defaultMessage: 'Start a 7-day trial',
        })}
      </Button>
    </div>
  );
};

export const PublicModeError = TypedMemo(PublicModeErrorComponent);
